import React from "react";
import { Row, Alert } from "antd";
import InfiniteScroll from "react-infinite-scroller";
import useInfiniteQuery from "hooks/useInfiniteQuery";

// graphql
import GET_FUTURE_CLASSES from "graphql/queries/GetFutureClasses";

// custom component
import ClassList from "common/class_card/ClassList";
import { CenteredLoading } from "common/loading";

const DEFAULT_PAGE_SIZE = 12;

function FutureClasses() {
  const {
    loading,
    error,
    nodes: lessons,
    loadMore,
    pageInfo,
  } = useInfiniteQuery("bookedClasses", GET_FUTURE_CLASSES, {
    variables: {
      first: DEFAULT_PAGE_SIZE,
    },
  });

  if (loading) {
    return <Alert type="info" message="Loading..." />;
  }

  if (error) {
    return (
      <Alert
        type="error"
        message="Error loading classes. Please check your internet or let us know if this keeps happening."
      />
    );
  }

  return (
    <div>
      <InfiniteScroll
        pageStart={0}
        loadMore={loadMore}
        hasMore={pageInfo?.hasNextPage}
        loader={<CenteredLoading key={pageInfo?.startCursor} />}
      >
        <Row gutter={24}>
          <ClassList lessons={lessons || []} />
        </Row>
      </InfiniteScroll>
    </div>
  );
}

export default FutureClasses;
